import React from "react";

import Tooltip from "shared/components/Tooltip";

import {
  COSIGN_PROPERTY_STATUS_HELPER_COPY,
  COSIGN_PROPERTY_STATUS_LABELS,
} from "./cosignDashboard.config";
import { StatusBadge, StatusBadgeWrapper } from "./styled";

interface CosignStatusBadgeProps {
  status: string | null | undefined;
}

/**
 * Renders a color-coded status badge with CS helper copy on hover (PRODUCT-988 AC).
 *
 * @param status - Raw status from the Cosign API (`active`, `onboarding`, `disabled`, or unknown).
 */
const CosignStatusBadge: React.FC<CosignStatusBadgeProps> = ({ status }) => {
  const normalized = (status || "unknown").toLowerCase();
  const label =
    COSIGN_PROPERTY_STATUS_LABELS[normalized] ||
    (status ? status : "Unknown");
  const helperCopy =
    COSIGN_PROPERTY_STATUS_HELPER_COPY[normalized] ||
    COSIGN_PROPERTY_STATUS_HELPER_COPY.unknown;

  const badge = (
    <StatusBadge $variant={normalized} data-testid="cosign-property-status">
      {label}
    </StatusBadge>
  );

  return (
    <Tooltip title={helperCopy} placement="top">
      <StatusBadgeWrapper
        data-testid="cosign-property-status-wrapper"
        aria-label={`${label}. ${helperCopy}`}
      >
        {badge}
      </StatusBadgeWrapper>
    </Tooltip>
  );
};

export default CosignStatusBadge;
